import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const productDevelopmentPhases = [
  {
    step: "01",
    title: "Product & User Discovery",
    detail:
      "We identify high-value opportunities, user flows, and where AI creates meaningful product differentiation.",
  },
  {
    step: "02",
    title: "Experience & System Design",
    detail:
      "We design UX, model interactions, and production architecture for speed, reliability, and maintainability.",
  },
  {
    step: "03",
    title: "Build & Validate",
    detail:
      "We ship an AI-powered MVP and evaluate quality, latency, and adoption signals against product goals.",
  },
  {
    step: "04",
    title: "Launch & Optimize",
    detail:
      "We harden production systems, monitor live usage, and iterate with your product team on business outcomes.",
  },
];

const ProductDevelopmentPage = () => {
  return (
    <ServiceTrackPage
      trackLabel="Product Development Track"
      title="Product Development for AI-Native Experiences"
      accentLine="From product thesis to production launch."
      description="We design and ship AI-native products across customer and internal platforms, with execution grounded in measurable user and business outcomes."
      topPrimaryCtaLabel="Book a Product Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="product-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "AI product strategy aligned to user behavior and business goals",
        "Production architecture for models, APIs, and product workflows",
        "Evaluation model for quality, latency, and commercial impact",
        "Launch roadmap from MVP release to scale milestones",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "6-12", label: "weeks to mvp launch" },
        { value: "2x", label: "faster iteration velocity" },
        { value: "99.9%", label: "target service uptime" },
        { value: "1", label: "aligned product roadmap" },
      ]}
      phases={productDevelopmentPhases}
      finalEyebrow="Final Step"
      finalTitleLine="Ready to ship an AI product users adopt?"
      finalAccentLine="Build quickly. Validate early. Scale confidently."
      finalDescription="Start with a focused product sprint that aligns user value, technical feasibility, and delivery velocity from day one."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default ProductDevelopmentPage;
